<template>
	<div class="main-footer">
		<div class="link-container">
			<div class="sns">
				<ul class="sns_items">
					<li class="sns_item">
						<a href="https://www.facebook.com/mamezou.jp/" target="_blank"
							><img src="../../assets/common/icon_fb.png" alt="FaceBook" width="121" height="121"
						/></a>
					</li>
					<li class="sns_item">
						<a href="https://mobile.twitter.com/mamezoudev" target="_blank"
							><img src="../../assets/common/icon_twitter.png" alt="Twitter" width="121" height="121"
						/></a>
					</li>
					<li class="sns_item is-linked">
						<a href="https://jp.linkedin.com/company/%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE%E8%B1%86%E8%94%B5" target="_blank"
							><img src="../../assets/common/icon_linked.png" alt="LinkedIn" width="141" height="120"
						/></a>
					</li>
					<li class="sns_item is-note">
						<a href="https://note.com/mamezou_info" target="_blank"
							><img src="../../assets/common/icon_note.png" alt="note" width="120" height="120"
						/></a>
					</li>
				</ul>
			</div>
			<div class="bnr">
				<ul class="bnr_items">
					<li class="bnr_item">
						<a href="https://developer.mamezou-tech.com/" target="_blank"
							><img src="../../assets/common/bnr_footer01.png" alt="豆蔵デベロッパーサイト" width="675" height="170"
						/></a>
					</li>
					<li class="bnr_item">
						<a href="https://www.mamezou.com/book" target="_blank"
							><img src="../../assets/common/bnr_footer02.png" alt="豆蔵社員・関係者の本" width="675" height="170"
						/></a>
					</li>
					<li class="bnr_item">
						<a href="https://mamezou.connpass.com/" target="_blank"
							><img src="../../assets/common/bnr_footer03.png" alt="豆蔵席" width="675" height="170"
						/></a>
					</li>
				</ul>
			</div>
		</div>
		<div class="logo">
			<a href="https://www.mamezou.com/" target="_blank"><img src="../../assets/common/logo.png"/></a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main-footer {
	width: 100%;
	margin-bottom: 50px;
	margin-top: 60px;
	@media print, screen and (min-width: 1161px) {
		margin-top: 150px;
	}
}

.link-container {
	img {
		vertical-align: bottom;
		max-width: 100%;
	}
}

.sns {
	margin: 0 auto;
	&_items {
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		gap: 28px;
		@media print, screen and (min-width: 1161px) {
			gap: 40px;
		}
	}

	&_item {
		width: 38px;
		@media print, screen and (min-width: 1161px) {
			width: 60px;
		}
		&.is-linked {
			width: 44px;
			@media print, screen and (min-width: 1161px) {
				width: 70px;
			}
		}
		&.is-note {
			width: 60px;
			@media print, screen and (min-width: 1161px) {
				width: 88px;
			}
		}
	}
}

.bnr {
	width: 75%;
	margin: 40px auto 0;
	@media print, screen and (min-width: 1161px) {
		width: 100%;
		margin-top: 55px;
	}
	&_items {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
		@media print, screen and (min-width: 1161px) {
			flex-direction: row;
			justify-content: center;
			gap: 35px;
		}
	}
	&_item {
		@media print, screen and (min-width: 1161px) {
			width: 340px;
		}
	}
}
.logo {
	width: 72px;
	margin: 60px auto 0;
	@media print, screen and (min-width: 1161px) {
		width: 80px;
		margin-top: 110px;
	}
}
</style>
